import { AppSettings } from '../../../settings';
import { Component, OnInit, Input } from '@angular/core';
import { UnpaidDetails } from '../unpaid.model';

@Component({
  selector: '[app-unpaid-item]',
  templateUrl: './unpaid-item.component.html',
  styleUrls: ['./unpaid-item.component.scss']
})
export class UnpaidItemComponent implements OnInit {
  @Input() unpaidDetails: UnpaidDetails;
  details = false;

  currencySuffix: string;
  constructor(
    private _settings: AppSettings
  ) {
    this.currencySuffix = _settings.getCurrencySuffix(new Date());
  }

  ngOnInit() {
  }

  toggleDetails(){
    this.details = !this.details;
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/unpaid/unpaid-item/unpaid-item.component.ts